import React from "react";
import { useParams } from "react-router-dom";
import EventsCalendar from "./EventsCalendar";

/**
 * Standalone calendar routes:
 *   /calendar            -> month (redirect)
 *   /calendar/month      -> month view
 *   /calendar/week       -> week view (current week)
 *   /calendar/week/:date -> week containing :date (YYYY-MM-DD)
 *   /calendar/day        -> day view (today)
 *   /calendar/day/:date  -> day view for :date (YYYY-MM-DD)
 *
 * The `key` remounts EventsCalendar when the view or date in the URL changes so
 * the initial view/date re-seed cleanly on a fresh deep-link.
 */
export default function CalendarRoute({ view = "month" }) {
  const { date } = useParams();
  return (
    <EventsCalendar
      key={`${view}:${date || "today"}`}
      initialView={view}
      initialDate={date || null}
    />
  );
}
